import FontAwesomeIcon from "app/components/layouts/Icons/FontAwesome";
import { faMusic } from "@fortawesome/free-solid-svg-icons";
import Image from 'app/components/layouts/Image';
import Link from 'next/link';
import env from '.env.json';

const ListSinger = ({ singers }) => {
  return (
    <div className="mt-2 singers row mx-1">
      {
        (singers || []).map((singer) => {
          return (
            <div className='col-md-3 col-sm-6 col-xs-6 px-2 center-box' key={singer._id}>
              <div className={`mb-3 wrap-box-content wrap-box-singer`}>
                <Link href={`/song/singer/${singer.slug}`}>
                  <div className="m-1">
                    <div className='position-relative wrap-image'>
                      <Image
                        className="rounded-circle align-middle d-inline-block my-auto"
                        alt={singer.name}
                        disableAuto
                        width={95}
                        height={95}
                        src={`${env.URL_API_FILE}/${singer.image}`}
                      />
                    </div>
                    <div className="overflow-hidden mt-1">
                      <div className="wrap-box-title text-center">{singer.name}</div>
                      <small className="text-center badge badge-info px-2">
                        <FontAwesomeIcon className="px-1" icon={faMusic} />
                        {singer.music_count}
                      </small>
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          )
        })
      }
    </div>
  )
}

export default ListSinger;
